export default __webpack_public_path__ + "locales/de/Webhooks.json?hash=78278fd82383881517af87d1d3a20035";